import TextClip from "../../animation/text/TextClip";
import style from "./SliderNote.module.css";

function SliderNote({ position, text: { title, body }, selected }) {
  return (
    <div
      className={
        "position-absolute " +
        style.box +
        " " +
        (position === 1 ? style.positionRight : style.positionLeft)
      }
    >
      <div>
        <TextClip type={0} show={selected}>
          <p>{title}</p>
        </TextClip>
        <TextClip type={0} show={selected}>
          <p style={{ whiteSpace: "pre-line" }}>{body}</p>
        </TextClip>
      </div>
    </div>
  );
}

export default SliderNote;
